export const MARK_OFFER_PROVIDED = "MARK_OFFER_PROVIDED";
export const REMOVE_OFFER_DATA = "REMOVE_OFFER_DATA";



// WEBPACK FOOTER //
// ./modules/launch-offers-appevent-utility/actions/actionTypes.ts